
export const Analytics = {
  namespaced: true,
  state: {

  },
  getters: {

  },
  mutations: {

  },
  actions: {
    /**
     * スクリーン名を送信
     * @param {Object} { commit }
     * @param {String} payload.name
     */
    trackScreen ({ commit }, payload) {
      console.log('trackScreen', payload)
      try {
        if (window.Android && window.Android.firebaseScreen) {
          // Androidの場合
          window.Android.firebaseScreen(JSON.stringify(payload))
        } else if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.firebaseScreen) {
          // iOSの場合
          console.log('iOSのwindow.webkit.messageHandlers.firebaseScreen コールします')
          window.webkit.messageHandlers.firebaseScreen.postMessage(payload)
        } else {
          console.log('No native APIs found.', payload)
        }
      } catch (e) {
        console.log(e)
        console.warn(e)
      }
    },
    /**
     * イベント送信
     * @param {Object} { commit }
     * @param {String} payload.name
     * @param {String} payload.params.itemId
     * @param {String} payload.params.itemName
     * @param {String} payload.parama.contentType
     */
    trackEvent ({ commit }, payload) {
      console.log('trackEvent', payload)
      try {
        if (window.Android && window.Android.firebaseEvent) {
          // Androidの場合
          window.Android.firebaseEvent(JSON.stringify(payload))
        } else if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.firebaseEvent) {
          // iOSの場合
          console.log('iosのwindow.webkit.messageHandlers.firebaseEventコールします')
          window.webkit.messageHandlers.firebaseEvent.postMessage(payload)
        } else {
          console.log('No native APIs found.', payload)
        }
      } catch (e) {
        console.log(e)
        console.warn(e)
      }
    }
  }
}
